import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Loading, TableLayout } from "../../components"
import moment from "moment"
import * as ApiHelper from "../../ApiHelper"
import { LoadModalWithLabel } from "./"
import { ToastContainer, ToastMessage } from "react-toastr"
import Util from "../../Util"
class ReciboForm extends Component {
  constructor() {
    super()
    this.sendForm = this.sendForm.bind(this)
    this.delete = this.delete.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.getTermoById = this.getTermoById.bind(this)
    this.onChangeRecibo = this.onChangeRecibo.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.state = {
      showLoad: false,
      showForm: false,
      initialTermos: []
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  resetForm() {
    this.setState({
      nome: "",
      cpf: "",
      unidade: "",
      numeroContrato: "",
      nomeServidor: "",
      observacao: "",
      clausula: ""
    })
  }
  getTermoById(id) {
    return this.state.initialTermos.filter(termo => {
      return termo.id === id
    })[0]
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  componentWillMount() {
    this.getTermos()
  }
  onChangeRecibo(selectedItem) {
    var newValue = selectedItem.value
    this.setState({
      termo: newValue,
      error: ""
    })
  }
  getTermos() {
    ApiHelper.getTermosDeApostilamento((termos, error) => {
      if (!error) {
        var termosMapped = termos.map(termo => {
          const dateFormatted = moment(termo.created_at).format("DD/MM/YYYY")
          const unidadeOrcamentaria =
            termo.contrato.unidade_orcamentaria.uni_orc
          return {
            value: termo.id,
            label: `${dateFormatted} - ${unidadeOrcamentaria}`
          }
        })
        termosMapped.shift()
        this.setState({
          termos: termosMapped,
          initialTermos: termos,
          showForm: true
        })
      } else {
        console.log(error)
      }
    })
  }
  delete(id, index) {
    this.toggleLoadModal()
    ApiHelper.deleteTermoDeApostilamento(id, error => {
      this.toggleLoadModal()
      if (error) {
        this.addAlert("", "Ocorreram erros")
      } else {
        var oldRecibos = this.state.initialTermos
        oldRecibos.splice(index, 1)
        this.setState({
          initialTermos: oldRecibos
        })
      }
    })
  }
  sendForm(id) {
    const termo = this.getTermoById(id)
    var params = {
      tipo_relatorio: "Termo de apostilamento",
      contrato_id: termo.contrato_id,
      data: termo.data,
      secretario: termo.secretario,
      modificacoes: termo.modificacoes,
      clausula: termo.clausula,
      reimpressao: true,
      id: id
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, (relatorio, error) => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Termo de apostilamento.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        this.props.callBack()
      } else {
        this.handleErrors(error)
        this.setState({
          formError: "Não existem baixas nesse período"
        })
      }
    })
  }
  render() {
    if (!this.state.showForm) {
      return <Loading />
    }
    var tableHeaders = [
      "Ordem",
      "Contrato",
      "CNPJ da secretaria",
      "Unidade orcamentaria",
      "Data",
      "Ações"
    ]
    var buttons = []
    var additionalButtons = []
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModalWithLabel
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <TableLayout
          headerButtons={buttons}
          sizeClass=""
          additionalButtons={additionalButtons}
          backgroundColor="as-blue"
          title="Termos de apostilamento"
          subtitle="Termos de apostilamento anteriormente emitidos"
        >
          <table style={{ marginTop: "20px" }} className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.state.initialTermos.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-1">{row.ordem_label}</td>
                    <td className="col-md-3">{row.contrato.num_contrato}</td>
                    <td className="col-md-3">
                      {Util.getMaskedCPFCNPJ(row.contrato.unidade_orcamentaria.cnpj)}
                    </td>
                    <td className="col-md-2">
                      {row.contrato.unidade_orcamentaria.uni_orc}
                    </td>
                    <td className="col-md-2">
                      {moment(row.data).format("DD/MM/YYYY")}
                    </td>
                    <td className="td-actions text-right">
                      <button
                        type="button"
                        rel="tooltip"
                        title="Reimprimir termo"
                        onClick={() => this.sendForm(row.id)}
                        className="btn btn-info btn-simple btn-xs"
                      >
                        <i className="material-icons">local_printshop</i>
                      </button>
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover termo"
                        onClick={() => this.delete(row.id, key)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">close</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(ReciboForm)



// WEBPACK FOOTER //
// ./src/views/modais/TermoDeApostilamentoForm.js